import React, { createContext, useContext } from 'react';

import { useSelector } from 'react-redux';

import useMessages from 'hooks/useMessages';
import { ChildrenPropType } from 'libs/proptypes';
import { selectActiveProduct } from 'selectors';

import { useQuestionGroups } from '../hooks/useQuestionGroups';
import { useQuestions } from '../hooks/useQuestions';

const QuestionsContext = createContext(null);

const propTypes = {
  children: ChildrenPropType.isRequired,
};

const defaultProps = {};

export function QuestionsProvider({ children }) {
  const messages = useMessages({ initial: '' });
  const merchantProduct = useSelector(selectActiveProduct);
  const { loading: questionsLoading, ...questions } = useQuestions(merchantProduct);
  const { loading: groupsLoading, ...groups } = useQuestionGroups(merchantProduct);

  const contextValue = {
    ...messages,
    ...questions,
    ...groups,
    loading: questionsLoading || groupsLoading,
    merchantProduct,
    messageOperations: {
      showMessage: messages.showMessage,
      showSuccess: messages.showSuccess,
      showError: messages.showError,
      showWarning: messages.showWarning,
      showInfo: messages.showInfo,
      clearMessage: messages.clearMessage,
    },
  };

  return <QuestionsContext.Provider value={contextValue}>{children}</QuestionsContext.Provider>;
}

QuestionsProvider.propTypes = propTypes;
QuestionsProvider.defaultProps = defaultProps;

export function useQuestionsContext() {
  const context = useContext(QuestionsContext);
  if (!context) {
    throw new Error('useQuestionsContext must be used within a QuestionsProvider');
  }
  return context;
}
